import { Col, DatePicker, Divider, Form, Input, Radio, Row, Select } from 'antd'

import { IDNP_REGEX } from 'src/app-constants'
import { requiredRules } from 'src/components'
import {
  dayMonthYearBackSlash,
  disableLegalAgeDate,
  legalAgePickerValue
} from 'src/libs'
import { useLocales } from 'src/locales'

export const ProfileSettingsFormFields = () => {
  const { t } = useLocales()

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col xs={24} md={12} xl={8}>
          <Form.Item
            name="lastName"
            label={t('form.last_name')}
            rules={requiredRules}
          >
            <Input disabled placeholder={t('form.last_name')} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item
            name="firstName"
            label={t('form.first_name')}
            rules={requiredRules}
          >
            <Input disabled placeholder={t('form.first_name')} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item
            name="idnp"
            label={t('form.idnp')}
            rules={requiredRules?.concat({
              pattern: IDNP_REGEX,
              message: t('form.idnp_error')
            })}
          >
            <Input disabled placeholder={t('form.idnp')} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item
            name="dateOfBirth"
            label={t('form.birth_date')}
            rules={requiredRules}
          >
            <DatePicker
              disabled
              className="full-width"
              placeholder={t('form.birth_date')}
              disabledDate={disableLegalAgeDate}
              defaultPickerValue={legalAgePickerValue}
              format={dayMonthYearBackSlash}
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item
            name="email"
            label={t('form.email')}
            rules={requiredRules?.concat({ type: 'email' })}
          >
            <Input placeholder={t('form.email')} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item
            name="phoneNumber"
            label={t('form.contact_number')}
            rules={requiredRules}
          >
            <Input placeholder={t('form.contact_number')} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name="gender"
            label={t('form.gender')}
            rules={requiredRules}
          >
            <Radio.Group disabled>
              <Radio value="male">{t('form.male')}</Radio>
              <Radio value="female">{t('form.female')}</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item
            name="residenceCity"
            label={t('cases.residential_address')}
          >
            <Input placeholder="mun. Chisinau" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item name="residenceAddress" label={<></>}>
            <Input placeholder="bul. Moscovei" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={4}>
          <Form.Item name="residenceAddressLine2" label={<></>}>
            <Input placeholder="5/5" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={4}>
          <Form.Item name="residenceAddressAppartment" label={<></>}>
            <Input placeholder="ap. 90" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item name="city" label={t('form.address')}>
            <Input placeholder="mun. Chisinau" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item name="address" label={<></>}>
            <Input placeholder="bul. Moscovei" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={4}>
          <Form.Item name="addressLine2" label={<></>}>
            <Input placeholder="5/5" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={4}>
          <Form.Item name="addressAppartment" label={<></>}>
            <Input placeholder="ap. 90" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Form.Item
            name="systemLanguage"
            label={t('settings.profile_default_language')}
            rules={requiredRules}
          >
            <Select
              placeholder={t('settings.profile_default_language')}
              options={[
                { label: 'Română', value: 'ro' },
                { label: 'Русский', value: 'ru' }
              ]}
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider />
    </>
  )
}
